//dependencies
import React from "react";

import { faTimesCircle } from "@fortawesome/pro-solid-svg-icons";

// components
import Chip, { ChipProps } from "../..";

interface DeletableChipProps extends Omit<ChipProps, "onRightIconClick" | "rightIcon"> {
	color?: ChipProps["color"];
	className?: string;
	maxWidth?: number;
	/**
	 * function to be ran when icon is clicked
	 */
	onDelete?: () => void;
}
/**
 * @deprecated

 */
const DeletableChip: React.FC<DeletableChipProps> = ({
	label,
	onDelete,
	avatarID,
	leftIcon,
	onLeftIconClick,
	color,
	className = "",
	maxWidth,
}) => {
	return (
		<Chip
			label={label}
			rightIcon={faTimesCircle}
			onRightIconClick={onDelete}
			avatarID={avatarID}
			leftIcon={leftIcon}
			onLeftIconClick={onLeftIconClick}
			color={color}
			className={`${className}`}
			maxWidth={maxWidth}
			labelProps={{
				className: "py-line-clamp-1 block min-w-0 !whitespace-normal break-words",
			}}
		/>
	);
};

/** @deprecated */
export default DeletableChip;
